export type OpportunityRow = {
  id: number
  name: string
  domain: string
  meals_per_day: number
}

export const MOCK_OPPORTUNITIES: OpportunityRow[] = [
  {
    id: 1,
    name: 'Compass Group',
    domain: 'compass-usa.com',
    meals_per_day: 45000,
  },
  { id: 2, name: 'Aramark', domain: 'aramark.com', meals_per_day: 32000 },
  { id: 3, name: 'Sodexo', domain: 'sodexo.com', meals_per_day: 28000 },
  {
    id: 4,
    name: 'Elior North America',
    domain: 'elior-na.com',
    meals_per_day: 12000,
  },
  { id: 5, name: 'Flik Hospitality', domain: 'flik.com', meals_per_day: 8500 },
  {
    id: 6,
    name: 'Thompson Hospitality',
    domain: 'thompsonhosp.com',
    meals_per_day: 6200,
  },
  {
    id: 7,
    name: 'Restaurant Associates',
    domain: 'ra-dining.com',
    meals_per_day: 5100,
  },
  {
    id: 8,
    name: 'Culinart Group',
    domain: 'culinart.com',
    meals_per_day: 4400,
  },
  {
    id: 9,
    name: 'Guckenheimer',
    domain: 'guckenheimer.com',
    meals_per_day: 3800,
  },
  {
    id: 10,
    name: 'Lancer Hospitality',
    domain: 'lancerhospitality.com',
    meals_per_day: 2900,
  },
  { id: 11, name: 'Eurest Dining', domain: 'eurest.com', meals_per_day: 2200 },
  {
    id: 12,
    name: 'CURA Hospitality',
    domain: 'curahospitality.com',
    meals_per_day: 1800,
  },
  {
    id: 13,
    name: 'Whitsons Culinary',
    domain: 'whitsons.com',
    meals_per_day: 1400,
  },
  {
    id: 14,
    name: 'Harvest Table',
    domain: 'harvesttable.com',
    meals_per_day: 950,
  },
  {
    id: 15,
    name: 'Perkins Management',
    domain: 'perkinsmgmt.com',
    meals_per_day: 700,
  },
]

/** Opportunity ids — what deals/contacts carry as their `opportunity_id` FK. */
export const OPPORTUNITY_IDS: number[] = MOCK_OPPORTUNITIES.map((o) => o.id)

/** id → opportunity lookup. The hub: deals and contacts both key into this. */
export const opportunityById: ReadonlyMap<number, OpportunityRow> = new Map(
  MOCK_OPPORTUNITIES.map((o) => [o.id, o])
)
